import { Component, Input, Output, EventEmitter } from '@angular/core';

import { InspectionPoint } from '../../../shared/models/index';

@Component({
    selector: 'addpoint-points',
    templateUrl: './point-list.component.html',
    standalone: false
})
export class AddPointPointListComponent {
  @Input() public points: InspectionPoint;
  @Output() public toggleSelectInspectionPoint: EventEmitter<any> = new EventEmitter();
  public selection: any = {};
  errorMessage: string;

  public loading: Boolean = true;

  constructor() {}

  public selectInspectionPoint(point: InspectionPoint) {
    this.toggleSelectInspectionPoint.emit(point);
  }
}
